import { useNavigate } from 'react-router-dom';

const services = [
  {
    icon: 'ri-building-line',
    title: 'Framing',
    description: 'Expert structural framing for residential and commercial projects. We ensure solid foundations and precise construction that meets all building codes and standards.',
    link: '/services/framing'
  },
  {
    icon: 'ri-home-line',
    title: 'Siding',
    description: 'Professional siding installation and replacement services. From vinyl to fiber cement, we enhance your property\'s curb appeal and weather protection.',
    link: '/services/siding'
  },
  {
    icon: 'ri-home-4-line',
    title: 'Roofing',
    description: 'Complete roofing solutions including installation, repair, and replacement. Quality materials and expert craftsmanship to protect your investment.',
    link: '/services/roofing'
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Decking',
    description: 'Custom deck design and construction to expand your outdoor living space. Durable materials and beautiful finishes that withstand the elements.',
    link: '/services/decking'
  },
  {
    icon: 'ri-door-open-line',
    title: 'Windows & Doors',
    description: 'Energy-efficient window and door installation. Improve your property\'s aesthetics, security, and energy performance with quality products.',
    link: '/services/windows-doors'
  },
  {
    icon: 'ri-hammer-line',
    title: 'Remodeling',
    description: 'Complete kitchen, bathroom, basement, and whole-home remodeling services. We transform your existing spaces into beautiful, functional living areas.',
    link: '/services/remodeling'
  },
];

export default function Services() {
  const navigate = useNavigate();

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="mb-4">
            <span className="text-brand text-sm font-semibold uppercase tracking-wider">
              What We Do
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Comprehensive Construction Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From foundation to finish, we handle every phase of your construction project with precision and care
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-brand group-hover:scale-110 transition-transform`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed mb-6">
                {service.description}
              </p>

              {/* Learn More Link */}
              <a
                href={service.link}
                className="inline-flex items-center text-brand font-medium hover:text-brand-dark transition-colors whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(service.link);
                }}
              >
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
